class ApiService {

    constructor() {
       // this.url = "http://127.0.0.1:82/calendar_2017/";
      //  this.app = "http://127.0.0.1:82/";

        this.url = " https://api.kaleidosapp.com/apiv2.node/NaturalRemedies/calendar_2017/";
        this.app = " https://api.kaleidosapp.com/apiv2.node/NaturalRemedies/";


        this.CurrentLanguage = "en";
        this.allowedLanguages = ["en", "it"];

        this.pages = {};
        this.menuItems = [];
        this.pagesData = {};

        this.pages['calendar'] = {};
        this.pages['calendar']['it'] = "il_calendario_dell_avvento";
        this.pages['calendar']['en'] = "the_advent_calendar";

        this.pagesData['calendarMain'] = {};
        this.pagesData['calendarMain']['title'] = {};
        this.pagesData['calendarMain']['title']['it'] = "Il calendario dell'avvento di Rimedi Naturali";
        this.pagesData['calendarMain']['title']['en'] = "The Natural Remedies Advent Calendar";

        this.pagesData['calendar'] = {};
        this.pagesData['calendar']['title'] = {};
        this.pagesData['calendar']['title']['it'] = "Calendario dell'avvento";
        this.pagesData['calendar']['title']['en'] = "Advent Calendar";
        this.pagesData['calendar']['data'] = {};
        this.pagesData['calendar']['data']['it'] = "eyJkIjp7InBhdGgiOiJBdnZlbnRvXzIwMTcvaXRfaW50cm8uanNvbiJ9LCJoIjoiVlRWM3AyYTJsRHZDQkdmREhyKzM3aE40YXVTWFh3U0Q4TGxMNmxQby9GMWtTUTNVbHd2STI2VkVlSWkzMUdzLzZTM2dTdVVJdjVYZlVicjVKa1lmYXc9PSIsInQiOjE1MTEzNzk5MTYsIm0iOiI1Yzg1YjFlMWVhMGU2NDNkZWM4NGU4MzZlM2NkZjM3YSJ9";
        this.pagesData['calendar']['data']['en'] = "eyJkIjp7InBhdGgiOiJBdnZlbnRvXzIwMTcvZW5faW50cm8uanNvbiJ9LCJoIjoiM0ZvdTVNWXJ5THZlbThuZyswMGR1UmpPKzBIc0JqS3QzWlVxU3FNOFI0VW9KbWtqQkRwN0dobXB2RlpWeHpZL2M2RGZEM3R2R3ZCK2F1V0hsTzFzNGc9PSIsInQiOjE1MTE0NTI2NDYsIm0iOiI0NTk3OTM5YzQzOWM0M2U2Mzc0OTMzZGE3NjZkOWI1ZiJ9";


        this.pages['scarica'] = {};
        this.pages['scarica']['it'] = "scarica_l_app_rimedi_naturali";
        this.pages['scarica']['en'] = "get_the_app_natural_remedies";

        this.pagesData['scarica'] = {};
        this.pagesData['scarica']['title'] = {};
        this.pagesData['scarica']['title']['it'] = "Scarica l'app Rimedi Naturali";
        this.pagesData['scarica']['title']['en'] = "Get the app Natural Remedies";

        this.menuItems.push({ "rif" : "calendar", "icon" : "natale.png"});
        this.menuItems.push({ "rif" : "scarica", "icon" : "get_app_download.png"});



    }



    GetPageRif(rif) {

        for (let _key in this.pages) {
            for (let keySub in this.pages[_key]) {
                if (rif === this.pages[_key][keySub]) {
                    return _key;
                }
            }

        }

        return false;
    }

    GetImage(image) {

        let sizes = [];
        sizes.push({w : 1000, k : "big"});
        sizes.push({w : 500, k : "medium"});
        sizes.push({w : 250, k : "small"});

        const CurrentW = window.innerHeight;
        let DiffSized = sizes.map((item) =>{
            item.diff = Math.abs(item.w - CurrentW);
            return item;
        });

        DiffSized = DiffSized.sort((a,b) => {
            return a.diff - b.diff;
        });



        return image + "_" + DiffSized[0]['k'] + ".jpg";
    }

    ValidateLanguage(lang) {
        let language = "en";

        let ValidateLanguage = this.allowedLanguages.filter((obj) => {

            if (obj === lang) {
                return true;
            }
            return false;
        });

        if (ValidateLanguage.length > 0) {
            language = lang;
        }

        this.CurrentLanguage = language;

        return language;
    }

}

global
    .api = new ApiService();


// WEBPACK FOOTER //
// ./src/include/_Api.js